import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';
import { EmailScrapeMappingSchema } from './email-scrape-config.js';

/**
 * Email scraping config for extracting temporary passwords in automation.
 */
export const RcEmailScrapeConfigSchema = z
  .object({
    name: z.string().optional(),
    version: z.string().optional(),
    mappings: z
      .object({
        tempPass: EmailScrapeMappingSchema.optional(),
      })
      .strict()
      .optional(),
  })
  .strict()
  .describe('Email scraping config for extracting temporary passwords in automation.');

export type RcEmailScrapeConfig = z.infer<typeof RcEmailScrapeConfigSchema>;

/**
 * Remote control/automation configuration for QA testing.
 */
export const schema = z
  .object({
    advisor_email: z.string().email().describe('Advisor email for automation scenarios.').optional(),
    advisor_name: z.string().describe('Advisor display name for automation.').optional(),
    advisor_phone: z.string().describe('Advisor phone for automation.').optional(),
    advisor_otp_secret: z.string().describe('OTP secret for advisor authentication in automation.').optional(),
    driver_email: z.string().email().describe('Driver email for automation scenarios.').optional(),
    driver_name: z.string().describe('Driver display name for automation.').optional(),
    driver_phone: z.string().describe('Driver phone for automation.').optional(),
    email_scrape_config: RcEmailScrapeConfigSchema.optional(),
    rc_dealer_admin_config_id: z
      .number()
      .int()
      .describe('Reference to RC dealer admin configuration record.')
      .optional(),
  })
  .strict()
  .describe('Remote control/automation configuration for QA and automation systems.');

export type RcConfig = z.infer<typeof schema>;

export const definition = define({
  key: 'rc_config',
  schema,
  label: 'RC Config',
  description: 'Remote control/automation configuration for QA testing.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.EMAIL_SCRAPING.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
});
